import React from 'react';
import { HowItWorksConnections } from '../components/HowItWorksConnections';
import { ArchitectureDiagram } from '../components/ArchitectureDiagram';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { NarrativeSection } from '../components/NarrativeSection';
import { ToolComparison } from '../components/ToolComparison';
import { WallOfLove } from '../components/WallOfLove';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
export function HomeArchitecture() {
  return <>
      <HowItWorksConnections mode="hero" data-id="element-9521" data-mp="2kviazpxtsl3f" />
      <ArchitectureDiagram data-id="element-9522" data-mp="2kugrcx2quqa3" />
      <HowItWorksConnections mode="how" data-id="element-9523" data-mp="2kt5nyyd7nkji" />
      <LivesInSlack data-id="element-9524" data-mp="1x4w4i33gz8vj" />
      <ComputerUse data-id="element-9525" data-mp="1x4cvxczplwu6" />
      <CapabilityGrid data-id="element-9526" data-mp="1x3uum1y6wsfe" />
      <NarrativeSection data-id="element-9527" data-mp="1t42gl9q11u2n" />
      <ToolComparison data-id="element-9528" data-mp="1t4lw6js7g6di" />
      <WallOfLove data-id="element-9529" data-mp="1t3auqqm8fapk" />
      <PricingSection data-id="element-9530" data-mp="1t3u43ixtgqrz" />
      <ClosingCTA data-id="element-9531" data-mp="1t29gkd9x683m" />
    </>;
}